/** The QROS core language's annotation predicates: always available on a
 *  QROS store, never declared by an ontology, so no property search finds
 *  them. Surfaces that pick a predicate offer these beside what the search
 *  finds (UAT 2026-09-30: the entity page's Add statement could not name
 *  :altLabel or :comment, so no alternative label could take a language and
 *  no annotation a tag). */
export const CORE_ANNOTATION_PREDICATES: { uri: string; label: string }[] = [
  { uri: ':label', label: 'Label' },
  { uri: ':altLabel', label: 'AltLabel' },
  { uri: ':comment', label: 'Comment' },
  { uri: ':definition', label: 'Definition' },
  { uri: ':note', label: 'Note' },
  { uri: ':scopeNote', label: 'ScopeNote' },
  { uri: ':example', label: 'Example' },
];

/** The core predicates a typed text names: by the term, or by the word. */
export function corePredicatesMatching(text: string): { uri: string; label: string }[] {
  const q = text.trim().replace(/^:/, '').toLowerCase();
  if (!q) return [];
  return CORE_ANNOTATION_PREDICATES.filter(
    (p) => p.uri.slice(1).toLowerCase().includes(q) || p.label.toLowerCase().includes(q),
  );
}
